module.exports = {
  'cap': false,
  'curry': false,
  'fixed': false,
  'immutable': false,
  'rearg': false
};



//////////////////
// WEBPACK FOOTER
// ../~/lodash/fp/_falseOptions.js
// module id = 141
// module chunks = 1